export default {
  BusinessStockSynchronizationDetail: {
    basicInformation: 'Account Information',
    adjustCode: 'Logical Data Sync Number',
    warehouseCode: 'Logical Warehouse Code',
    warehouseName: 'Logical Warehouse Name',
    commodityDetails: 'Product Details',
    realityNum: 'Reality Num',
    planNum: 'Adjust Quantity Difference',
  }
};
